var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FormControlMixin } from '@open-wc/form-control';
import { property, query, state } from '@horizon/base/decorators.js';
import 'element-internals-polyfill';
export function ToggleInputMixin(SuperClass) {
    class HorizonToggleInput extends FormControlMixin(SuperClass) {
        constructor() {
            super(...arguments);
            /**
             * Sets the input value
             */
            this.value = '';
            /**
             * Set the checked state and sets input.checked
             */
            this.checked = false;
            /**
             * Set whether or not the input is required to have a value
             */
            this.required = false;
            /**
             * Set the input to be disabled
             */
            this.disabled = false;
            /**
             * Set the help text for the input
             */
            this.helperText = '';
            /**
             * Hides the help text for the input
             */
            this.hideHelperText = false;
        }
        /**
         * @private
         */
        get showErrors() {
            // only show the clear button if clearable, with a value
            // and not disabled or readonly
            return this.showError && !this.disabled;
        }
        // set a reactive property so that error messages will show when applicable
        /**
         * @private
         */
        validationMessageCallback(message) {
            this.internalErrorMessage = message;
        }
        /**
         * @private
         */
        shouldFormValueUpdate() {
            return this.checked === true;
        }
        /**
         * @private
         */
        updated(changed) {
            if (changed.has('value') || changed.has('checked')) {
                this.setValue(this.value);
            }
            if (changed.has('checked')) {
                this.internals.states[this.checked ? 'add' : 'delete']('--checked');
            }
        }
        /** Sets focus on the input. */
        focus(options) {
            this.validationTarget.focus(options);
        }
        /** Removes focus from the input. */
        blur() {
            this.validationTarget.blur();
        }
    }
    HorizonToggleInput.formControlValidators = [
        {
            key: 'valueMissing',
            message(instance) {
                if (instance.errorMessage) {
                    return instance.errorMessage;
                }
                return `${instance.displayName ? instance.displayName : 'This field'} is required`;
            },
            isValid(instance) {
                if (!instance.required) {
                    return true;
                }
                return instance.required && instance.checked;
            },
        },
    ];
    __decorate([
        state()
    ], HorizonToggleInput.prototype, "internalErrorMessage", void 0);
    __decorate([
        query('input')
    ], HorizonToggleInput.prototype, "validationTarget", void 0);
    __decorate([
        property()
    ], HorizonToggleInput.prototype, "name", void 0);
    __decorate([
        property({ type: String, attribute: 'display-name' })
    ], HorizonToggleInput.prototype, "displayName", void 0);
    __decorate([
        property({ type: String })
    ], HorizonToggleInput.prototype, "value", void 0);
    __decorate([
        property({ type: Boolean, reflect: true })
    ], HorizonToggleInput.prototype, "checked", void 0);
    __decorate([
        property({ type: Boolean })
    ], HorizonToggleInput.prototype, "required", void 0);
    __decorate([
        property({ type: Boolean, reflect: true })
    ], HorizonToggleInput.prototype, "disabled", void 0);
    __decorate([
        property({ type: String, attribute: 'helper-text' })
    ], HorizonToggleInput.prototype, "helperText", void 0);
    __decorate([
        property({ type: Boolean, attribute: 'hide-helper-text' })
    ], HorizonToggleInput.prototype, "hideHelperText", void 0);
    __decorate([
        property({ type: String, attribute: 'error-message', reflect: true })
    ], HorizonToggleInput.prototype, "errorMessage", void 0);
    return HorizonToggleInput;
}
//# sourceMappingURL=toggle-input-mixin.js.map